import { ChangeEvent, useEffect, useState } from 'react';
import { UseRadioButtonProps, UseRadioButtonValue } from './useRadioButton.types';
import useRadioGroupContext from '../../base-app/organisms/RadioGroup/useRadioGroupContext';

const useRadioButton = ({ name, value, disabled, checked, onChange: onChangeProp }: UseRadioButtonProps): UseRadioButtonValue => {
  const radioGroupCtx = useRadioGroupContext();
  const [isRadioChecked, setIsRadioChecked] = useState<boolean>();

  const isRadioValueChecked = (eventOrGroupValue: string | number, radioValue: string | number): boolean => {
    return eventOrGroupValue === radioValue;
  };

  // Handle radio group integrated case.
  if (radioGroupCtx !== undefined) {
    if (checked === undefined) {
      checked = isRadioValueChecked(radioGroupCtx.value, value);
    }
    if (name === undefined) {
      name = radioGroupCtx.name;
    }
    if (radioGroupCtx.disabled) disabled = true;
  }

  const onChange = radioGroupCtx != null ? radioGroupCtx.onChange : onChangeProp;

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setIsRadioChecked(isRadioValueChecked(event.target?.value, value));

    onChange?.(event, event.target?.value);
  };

  useEffect(() => {
    if (radioGroupCtx !== undefined) {
      setIsRadioChecked(isRadioValueChecked(radioGroupCtx.value, value));
    } else {
      setIsRadioChecked(checked);
    }
  }, [radioGroupCtx, value]);

  const isValueChecked =
    radioGroupCtx !== undefined ? isRadioValueChecked(radioGroupCtx.value, value) : checked ?? false;

  return {
    disabled,
    handleChange,
    isRadioChecked,
    isValueChecked,
    buttonName: name,
  };
};

export default useRadioButton;
